import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Route, Switch} from "react-router-dom";

import ListReportings from "./ListReportings";
import Reporting from "./Raporting";
import {Can} from "../../../ability-context";
import {PageLoader} from "../../components/Loader";
import {config} from "../../../config";
//import {canonical} from "../../../libs/helper";
import Helmet from "react-helmet";


class PcReporting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    render() {
        return (
            <div id="pc-reportings">
                <Helmet>
                    <title>{config.preTitle}Pc Moderation{config.postTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="card big">
                        {!this.props.currentUserInitialized ? (<PageLoader />) : (
                        <Can action={"moderation"} subject="Reporting" passThrough>
                            {can => {
                                return can ? (
                            <Switch>
                                <Route path={`${this.props.match.path}/:page([0-9]+)?`} exact component={ListReportings}/>
                                <Route path={`${this.props.match.path}/:reportId/:page([0-9]+)?`} exact component={Reporting}/>
                            </Switch>) : (
                                <div>vous n'etes pas autorisé</div>
                            )}}
                        </Can>)}
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        currentUserInitialized: state.currentUser.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(PcReporting);
